var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyExchange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0586 0.5H0.0585938V13.5H5.45859V26.5H20.6586V13.5H26.0586V0.5ZM18.4586 24.3H7.65859V13.5V8.1H18.4586V24.3ZM23.8586 11.3H20.6586V8.1H21.7586V5.9H20.6586H5.45859H4.35859V8.1H5.45859V11.3H2.25859V2.7H23.9586V11.3H23.8586Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0578 17.8002C15.4578 17.8002 17.3578 15.9002 17.3578 13.5002C17.3578 11.1002 15.4578 9.2002 13.0578 9.2002C10.6578 9.2002 8.75781 11.1002 8.75781 13.5002C8.75781 15.9002 10.6578 17.8002 13.0578 17.8002ZM13.0578 11.3002C14.2578 11.3002 15.2578 12.3002 15.2578 13.5002C15.2578 14.7002 14.2578 15.7002 13.0578 15.7002C11.8578 15.7002 10.8578 14.7002 10.8578 13.5002C10.8578 12.3002 11.8578 11.3002 13.0578 11.3002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.157 18.9004H11.957V22.2004H14.157V18.9004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyExchange);
export default __webpack_public_path__ + "static/media/money-exchange.c384cd7e96d3e9fd6ebd34a0bb674f2b.svg";
export { ForwardRef as ReactComponent };